export const MAX_SAFE_MONEY = 922337203468577;

export default {};
